import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router";

import { compose } from "redux";
import { Navigation } from "../AllEventPage/navigation";
import { EventListingComponent } from "../AllEventPage/eventListing";
import { convertSlugToTitle } from "../../util/commonFunctions";
import { getEventsList } from "../../actions";
import { LoaderComponent } from '../../components/loader';

let hierarchyArr = [
	{
		id: 1,
		name: 'all events',
		description: 'event list description',
		metaDescription: 'event list meta desc',
		url: "/all-events",
	},
  {
		id: 1,
		name: 'event list',
		description: 'event list description',
		metaDescription: 'event list meta desc',
    url: "",
	},
]

class EventList extends Component {
	state = {
		title: null,
    isUpcomingEvent: null,
    eventList: [],
	}

	componentDidMount = () => {
    let isUpcomingEvent = window.location.pathname.includes("upcoming");

		this.state.title = convertSlugToTitle(window.location.pathname.replace(/^\/|\/$/g, ''));
    this.state.isUpcomingEvent = isUpcomingEvent;
    this.state.eventList = isUpcomingEvent ? this.props.eventDetails.upcoming_events : this.props.eventDetails.previous_events
	}

  render() {
    return (
      <React.Fragment>
        {this.state.eventList && this.state.eventList.length > 0 &&       
          <div className="container">
            <section className="event-navigation">
              <Navigation
                isEventCrumb={true}
                hierarchy={hierarchyArr}
                eventName={this.state.eventList?.[0]?.title.en}
                imageUrl={this.state.eventList?.[0]?.event_image_file_base.path}
              />
              <h3 className="event-list-navigation-title">{this.state.title}</h3>
            </section>
            <section
              className="container event-list"
              ref={this.lazyLoadContainer}
            >
              <div className="row">
                <EventListingComponent
                  listing={this.state.eventList}
                  currentLanguage={this.props.currentLanguage}
                />
              </div>
            </section>
          </div>
        }
        <LoaderComponent isLoading={this.props.eventDetails.isListLoading}/>
			</React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    eventDetails: state.eventDetails,
    currentLanguage: state.language.currentLanguage,
  };
};

function mapDispatchToProps(dispatch) {
  return  {
    getEventsList: () => dispatch(getEventsList('all'))
  }
}

function loadData(store, match) {
  let actionArray = [
    store.dispatch(getEventsList("all")),
  ];
  return actionArray;
}

export default {loadData,
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(EventList)
};